class GameReview {

    constructor() {
        this.currentPage = 1;
    }

    reviewSubmitted(response) {
        setTimeout(function () {
            app.alert.success(response.header, response.text);
        }, 1500);
    }

    loadMore(id) {
        app.ajax.get('/services/game/reviews/get', {'id': id, 'page': ++this.currentPage}, function (response) {
            if (response.data) {
                jQuery('#reviews').append(response.data);
            } else {
                jQuery('#loadMoreReviewsLink').remove();
            }
        }.bind(this));
    }
}